// KAN-560 Day 3 item 14 (Paul 14628): the learner-facing name of the chat at /learn/agent.
//
// The page said "Capability agent" and the nav said "Agent"; the product calls it the AI
// Companion (Paul's wording on the About-you screen: "Things you told the AI Companion about
// yourself"). One place for the name, so the page title, the nav link and the strings that name
// it cannot drift apart. The other strings are the page's existing sentences with "agent"
// replaced by the product's name (copy for Paul to confirm, listed in the round notes).
export const COMPANION_NAME = 'AI Companion';
export const COMPANION_NAV_LABEL = 'Companion';

export const COMPANION_COPY = {
  title: COMPANION_NAME,
  speaker: 'Companion',
  notSwitchedOn: 'The AI Companion is not switched on for this environment yet.',
  intro:
    'Ask about your capabilities, your work, or where you want to get to. The Companion '
    + 'reads your profile and what it has previously learned about you, and draws on the '
    + 'capability data for your sector.',
  placeholder: 'Tell the Companion about your work, or ask it something.',
  quota: 'You have reached the Companion quota for now. Give it a moment.',
  failed: 'Something went wrong reaching the Companion. Try again in a moment.',
  // The existing "Sector data used — …" line, now with the sector's name only (no counts).
  sectorUsed: (sector) => `Sector data used — ${sector}`,
};
